import React from "react";
const Social = () => {
    return(
    <div className="home__social">
        <a href="https://www.instagram.com/__im.lucas_/" className="home__social-icon" target="blank">
             <i class="uil uil-instagram"></i>  
        </a>

        <a href="https://www.linkedin.com/in/manniss-d-05b05221a/" className="home__social-icon" target="blank"> 
        <i class="uil uil-linkedin"></i>
        </a>

        <a href="https://github.com/Manniss01" className="home__social-icon" target="blank"> 
        <i class="uil uil-github-alt">
        </i>
        </a>
    </div>
    )
}
export default Social;